import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

interface ConfirmationDialogProps {
    open: boolean;
    handleClose: (shouldDelete: boolean) => void;
    descMessage: string;
}

const ConfirmationDialog = ({open, handleClose, descMessage}: ConfirmationDialogProps) => {

    const handleClosDialog = (shouldDelete: boolean) => {
        handleClose(shouldDelete);
    }

  return (
    <React.Fragment >
      <Dialog
        open={open}
        onClose={(event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                handleClose(false);
            }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {descMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClosDialog(false)}>Cancel</Button>
          <Button onClick={() => handleClosDialog(true)} >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export default ConfirmationDialog;